var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3857 11.0772C23.3857 12.8619 22.8565 14.4989 21.9457 15.8651C20.6164 17.8344 18.5117 19.2252 16.0624 19.5821C15.6439 19.656 15.2131 19.6929 14.77 19.6929C14.3269 19.6929 13.8961 19.656 13.4776 19.5821C11.0283 19.2252 8.92359 17.8344 7.59431 15.8651C6.6835 14.4989 6.15425 12.8619 6.15425 11.0772C6.15425 6.31389 10.0067 2.46143 14.77 2.46143C19.5333 2.46143 23.3857 6.31389 23.3857 11.0772Z",
    stroke: "#FAFCFF",
    strokeWidth: 1.54515,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1547 22.7331L24.1238 23.2131C23.6684 23.3239 23.3115 23.6685 23.213 24.124L22.7822 25.9333C22.5484 26.9179 21.2929 27.2133 20.6406 26.4379L14.7696 19.693L8.89857 26.4502C8.24624 27.2256 6.9908 26.9302 6.75695 25.9455L6.32616 24.1362C6.21539 23.6808 5.85845 23.3239 5.41535 23.2254L3.3845 22.7454C2.44908 22.5239 2.11676 21.3546 2.79371 20.6776L7.59391 15.8774C8.92319 17.8468 11.0279 19.2376 13.4772 19.5945C13.8957 19.6684 14.3265 19.7053 14.7696 19.7053C15.2127 19.7053 15.6435 19.6684 16.0619 19.5945C18.5113 19.2376 20.616 17.8468 21.9453 15.8774L26.7455 20.6776C27.4224 21.3423 27.0901 22.5116 26.1547 22.7331Z",
    stroke: "#FAFCFF",
    strokeWidth: 1.54515,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4837 7.36032L16.2099 8.81268C16.3084 9.00961 16.5668 9.20655 16.8007 9.24348L18.1177 9.46502C18.9546 9.60041 19.1516 10.2158 18.5485 10.8189L17.5269 11.8405C17.3546 12.0128 17.2561 12.3451 17.3176 12.5913L17.613 13.8591C17.8469 14.856 17.3176 15.2499 16.4315 14.7206L15.2006 13.9944C14.9791 13.859 14.6098 13.859 14.3883 13.9944L13.1575 14.7206C12.2713 15.2376 11.742 14.856 11.9759 13.8591L12.2713 12.5913C12.3205 12.3575 12.2344 12.0128 12.062 11.8405L11.0405 10.8189C10.4374 10.2158 10.6343 9.61272 11.4712 9.46502L12.7882 9.24348C13.0098 9.20655 13.2682 9.00961 13.3667 8.81268L14.0929 7.36032C14.4498 6.5726 15.0899 6.5726 15.4837 7.36032Z",
    stroke: "#FAFCFF",
    strokeWidth: 1.54515,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievements);
export default __webpack_public_path__ + "static/media/achievements.3e5caea0cb5b8ec2749e3d0e63e9b674.svg";
export { ForwardRef as ReactComponent };